// this file added by Bearer Web Developer
export default function isSafari() {
  // This regex checks for "Safari" but excludes "Chrome" and "Android" to be more specific
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
  return isSafari;
}